import React, { useState, useContext } from 'react';
import axios from 'axios';
import * as Sentry from '@sentry/react'
import { FieldProps } from 'formik'

import FormikFieldCustomProps from "../field/formikfieldcustomprops";
import UserContext from '../../contexts/user';
import { EditIco } from '../../components/svgs';
import getEncodedImageUrl from '../get-encoded-image';

const ProfileImage: React.FC<FormikFieldCustomProps & FieldProps> = ({
  field,
  form,
  onChange
}) => {
  const userContext = useContext(UserContext);
  const [uploading, setUploading] = useState(false);
  return (
    <div className="text-center">
      {/* <pre>{JSON.stringify(field.value, null, 2)}</pre> */}
      <label htmlFor={field.name} style={{ opacity: uploading ? 0.5 : 1, pointerEvents: uploading ? 'none' : 'all' }}>
        {
          field.value
            ? <div className="profile-image-holder">
                {/* show uploaded image */}
                <img src={getEncodedImageUrl(field.value, 100,100)} alt="" className="upload-image-input" />
                <EditIco />
              </div>
            : <div className="profile-image-holder">
              <img src="/images/placeholder.svg" alt="" className="upload-image-input" />
              <EditIco />
            </div>
        }
      </label>
      <input id={field.name} type="file" className="d-none" accept="image/*" onChange={async (file) => {
        if (file.target.files && file.target.files.length === 1) {
          setUploading(true);
          const { name, type } = file.target.files[0];
          try {
            const token = await axios({
              method: 'GET',
              url: `${process.env.REACT_APP_API_ENDPOINT}/engagement/s3?objectName=${encodeURIComponent(name)}&contentType=${type}`,
              headers: {
                Authorization: userContext.authHeader
              }
            });
            const { publicUrl, signedUrl } = token.data;
            //  console.log('debug: signedUrl: ', signedUrl);
            //  console.log('debug: publicUrl: ', publicUrl);

            await axios.put(signedUrl, file.target.files[0], {
              headers: {
                'Content-Type': type
              }
            });
            //  console.log('debug: upload: ', upload, publicUrl);

            if(onChange) {
              onChange(publicUrl);
            }

            form.setFieldValue(field.name, publicUrl);
          } catch (e) {
            //  console.log('debug: error: ', e);
            //Sentry.captureException(e);
          }
          setUploading(false);
        }
      }} />
    </div>
  );
};


export default ProfileImage;
